import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import commonConstant from '../../common/_commonConstant';
import { getCookieToken } from '../../common/_commonFunction';
import { Loading } from '../../components';
import { history } from '../../helpers';
import { fetchLogout } from '../../actions';

class Logout extends Component {
  UNSAFE_componentWillMount() {
    if (!getCookieToken()) {
      return history.push(commonConstant.pathLogin);
    }
    return this.props.dispatch(fetchLogout());
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { logout } = this.props;

    if (nextProps.logout && nextProps.logout !== logout) {
      return history.push(commonConstant.pathLogin);
    }
  }

  render() {
    return <Loading />;
  }
}

Logout.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'logout': PropTypes.shape({}),
};

const mapStateToProps = ({ logout }) => ({ logout });

export default connect(mapStateToProps)(Logout);
